import { CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, Inject, InjectionToken, NgModule, Optional } from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {AppComponent} from './app.component';
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {AppRoutingModule} from "./app-routing.module";
import {BugsnagErrorHandler} from '@bugsnag/plugin-angular';
import Bugsnag from '@bugsnag/js';
import {environment} from "../environments/environment";
import {ErrorDialogComponent} from "./shared/errors-dialog/errors-dialog.component";
import {ErrorDialogService} from "./shared/errors-dialog/errors-dialog.service";
import {MatDialogModule} from "@angular/material/dialog";
import {MatButtonModule} from "@angular/material/button";
import {HttpClientModule} from "@angular/common/http";
import {PopupDialogComponent} from "./shared/popup/popup-dialog.component";
import {PopupDialogService} from "./shared/popup/popup-dialog.service";
import { inject } from '@vercel/analytics';

export const IS_ISOLATE_MODE = new InjectionToken<boolean>('isIsolateMode');

// Extend Window type with webkit property,
// required to check if iOS is running within a WKWebView browser instance.
declare global {
  interface Window {
    webkit?: any;
  }
}

// create a factory which will return the Bugsnag error handler
export function errorHandlerFactory(isIsolateMode: boolean)
{
  if (isIsolateMode)  {
    return new ErrorHandler();
  }
  return new BugsnagErrorHandler()
}


@NgModule({
  declarations: [
    AppComponent,
    ErrorDialogComponent,
    PopupDialogComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    MatDialogModule,
    MatButtonModule
  ],
  providers: [
    {
      provide: ErrorHandler,
      useFactory: errorHandlerFactory,
      deps: [IS_ISOLATE_MODE]
    }, ErrorDialogService, PopupDialogService],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule {
  constructor(@Inject(IS_ISOLATE_MODE) isIsolateMode: boolean) {
    // console.debug(`AppModule constructed in ${isIsolateMode ? 'isolated' : 'normal'} mode.`);

    // You can perform any additional setup here based on isIsolateMode

    // vercel analytics
    if (environment.vercelAnalytics) { inject(); }

    // configure Bugsnag
    const BUGSNAG_AGENT_URL = 'https://bugs-api.vuframe.com';
    // configure Bugsnag
    Bugsnag.start({
      apiKey: atob(environment.BUGSNAG_API_KEY),
      autoTrackSessions: false,
      appType: 'browser',
      appVersion: environment.version,
      releaseStage: environment.stage,
      logger: null,
      endpoints: {
        notify: BUGSNAG_AGENT_URL,
        sessions: BUGSNAG_AGENT_URL
      },
      onError: (err) => {
        return err.errors[0]?.errorMessage !== "WebAR file not found.";
      }
    })

    if (isIsolateMode) {
      // console.debug("isolate mode: session tracking disabled");
    }
    else {
      // start Bugsnag session tracking
      Bugsnag.startSession();
    }
  }
}
